export default __webpack_public_path__ + "static/media/b7.348c8506.jpg";